 

export default class ProfessionalAttachment {

    Id: string | undefined;
    DescriptionTasy: string;
    Description: string;
    FileName: string | undefined;
    EncriptId: string | undefined;
    AttachmentTypeTasyId: number;
    AttachmentTypeId: number;
    DeliveryDate: string | undefined;
    Expired: boolean | undefined;
    TasyCode: number | undefined;
    RemoveTasy: boolean | undefined;
    Mandatory: boolean | undefined;

    constructor() {
        this.DescriptionTasy = "";
        this.Description = "";
        this.AttachmentTypeId = 0;
        this.AttachmentTypeTasyId = 0;
    }
    
    static NewInstance() {
        return new ProfessionalAttachment();
    }
}